import React, { useState, Fragment, useRef, useEffect } from "react"
import { FaTrashAlt } from "react-icons/fa"
import { toast } from "react-toastify"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { deleteOrder } from "services"
import { ConfirmationModal, } from "components"
import { createPrintRequest } from "utils"
import classes from "./KtOrderCardDropDownDeleteButton.module.scss"

const KtOrderCardDropDownDeleteButton = props => {
  const { tableOrder, setTableOrders } = props

  const [t] = useTranslation()

  const printers =
    useSelector(state => state.printers)

  const serviceTypeName =
    useSelector(state => state.systemSettings.serviceTypeName)

  const [sending, setSending] = useState(false)
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false)

  const unmount = useRef(false)

  const print = async () => {
    const tableNumber =
      tableOrder.deliveryType === "dineIn"
        ? tableOrder.tableNumber
        : ""

    const printData = {
      serviceTypeName,
      tableNumber,
      date: tableOrder.date,
      code: tableOrder.code,
      items: tableOrder.items,
      accountRole: tableOrder.accountRole,
      deliveryService: tableOrder.deliveryService,
      deliveryType: tableOrder.deliveryType,
      customerFullName: tableOrder.customerFullName
    }

    await Promise.all(
      printers.map(
        async (printerSettings, printerIndex) => {
          const request = {
            printType: "deletedOrder",
            printerIndex,
            printData,
            printerSettings,
            saveToFailedPrints: true
          }

          try {
            await createPrintRequest(request)
          } catch (err) {
            console.log(err)
          }
        }
      )
    )
  }

  const handleDeleteOrder = async () => {
    setSending(true)

    const query =
      tableOrder.isGuestOrder ? { orderId: tableOrder._id } : {}

    try {
      await deleteOrder(tableOrder._id, query)

      print()

      if (unmount.current) return

      setTableOrders(prev =>
        prev.filter(to => to._id !== tableOrder._id)
      )
    } catch (err) {
      console.log(err)

      setSending(false)

      toast.error(
        t("حذف_سفارش_موفقیت_آمیز_نبود")
      )
    }
  }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  return (
    <Fragment>
      <button
        className={classes["dropdownItem"]}
        onClick={() => setOpenConfirmationModal(true)}
      >
        <FaTrashAlt
          size={16}
          color="var(--color-danger)"
        />
        <span className={classes["dropdownText"]}>
          {t("حذف")}
        </span>
      </button>

      <ConfirmationModal
        title={t("آیا_می_خواهید_سفارش_را_حذف_کنید")}
        show={openConfirmationModal}
        onConfirm={handleDeleteOrder}
        onHide={() => setOpenConfirmationModal(false)}
        loading={sending}
      />
    </Fragment>
  )
}

export default KtOrderCardDropDownDeleteButton